<template>
  <accordion-panel
    class="water-on-paper-dry-mass-section__accordion"
    id="water-on-paper-dry-mass-charts"
    :collapsed.sync="collapsed"
  >
    <template #title>
      <strong>{{
        $t('engineering.water-on-paper.water-on-paper-relative')
      }}</strong>
    </template>
    <b-row
      v-show="loading"
      class="my-5"
    >
      <b-col
        class="text-center"
        cols="12"
      >
        <s-loader size="lg" />
      </b-col>
    </b-row>
    <div v-show="!loading && waterOnPaperDryMassCharts.length">
      <b-row class="water-on-paper-dry-mass-section__subtitle-wrapper">
        <b-col
          class="water-on-paper-dry-mass-section__subtitle-content mb-2"
          v-for="(subtitle, subtitleIndex) in subtitles"
          cols="auto"
          sm="4"
          :key="subtitleIndex"
        >
          <div><i
              class="fas fa-square-full mr-2"
              aria-hidden="true"
              :class="subtitle.class"
            ></i> {{ $t(`engineering.water-on-paper.subtitles.${subtitle.text}`) }}</div>
        </b-col>
      </b-row>
      <b-row class="water-on-paper-dry-mass-section__chart-wrapper">
        <b-col
          class="water-on-paper-dry-mass-section__chart"
          v-for="(waterOnPaperChart, waterOnPaperIndex) in waterOnPaperDryMassCharts"
          cols="auto"
          :xl="colsByWindings"
          :key="waterOnPaperChart.windingId"
        >
          <water-on-paper-dry-mass-chart
            class="water-on-paper-dry-mass-section__chart-item"
            :chart-data="waterOnPaperChart"
            :winding-id="waterOnPaperIndex + 1"
            :is-collapsed="collapsed"
          />
        </b-col>
      </b-row>
    </div>
    <s-empty-list v-show="!loading && !waterOnPaperDryMassCharts.length" />
  </accordion-panel>
</template>

<script>
import AccordionPanel from '@/components/AccordionPanel';
import WaterOnPaperDryMassChart from './WaterOnPaperDryMassChart';

export default {
  name: 'WaterOnPaperDryMassSection',
  components: {
    AccordionPanel,
    WaterOnPaperDryMassChart,
  },
  props: {
    waterOnPaperDryMassCharts: {
      type: Array,
      default: () => ([]),
    },
    windingAmount: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    collapsed: false,
  }),
  computed: {
    colsByWindings() {
      const maxColumns = 12;
      if (!this.windingAmount) return maxColumns;
      return maxColumns / this.windingAmount;
    },
    subtitles() {
      return [
        {
          class: 'primary',
          text: 'water-on-paper-dry-mass',
        },
        {
          class: 'danger',
          text: 'admissible-water-on-paper',
        },
      ];
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  .water-on-paper-dry-mass-section
    &__accordion
      border: 1px solid $color-border-gray
      border-radius: 5px
    &__chart-item
      min-width: 200px
      margin: 5px 0
    &__chart
      display: inline-flex
      flex-direction: column
      flex: 1
  .primary
    color: var(--color-primary)
    font-size: 1.1em
  .danger
    color: var(--color-danger)
    font-size: 1.1em
    opacity: .5
  ::v-deep
    .accordion-panel
      &__header
        padding: 2px 15px !important
        font-weight: bold
</style>
